$(document).ready(function(){
  
    if(window.location.hash){
        let hash = window.location.hash.substring(1); 
        hash = hash.toLowerCase();
        if('creativerewards' == hash){
            if (window.SmileUI) {
                SmileUI.ready().then(smileUiInstance => {
                    SmileUI.openPanel();
                }).catch(err => {
                    console.log(err)
                });
            } else {
                document.addEventListener('smile-ui-loaded', () => {
                    SmileUI.ready().then(smileUiInstance => {
                        SmileUI.openPanel();
                    }).catch(err => {
                        console.log(err)
                    });
                });
            }
        }    
    }
  
    $(document).on('click', '.toggle-box', function(e){
        e.preventDefault();
        $(this).parent().find('.promo').toggleClass('active');
        $(this).parent().find('label').toggleClass('open');
        var x = window.pageXOffset,
        y = window.pageYOffset;
        $(window).one('scroll', function () {
            window.scrollTo(x, y);
        })
      
    });

    $(document).on('focusout', '.has-max-qty',function(){
        $('.max-qty-error').remove();
        let currentQty = parseInt($(this).val());
        let allowQty = parseInt($(this).attr('max'));
        if(currentQty > allowQty){
            $(this).val(allowQty) 
            $(this).parent().next().append(`<div class="max-qty-error"> Only maximum ${allowQty} quantity allowed per order</div>`);
        }
    })
})